import React from "react";
import { SvgIcon } from '@material-ui/core';
import clsx from 'clsx';
import { withStyles } from '@material-ui/styles';

const styles = theme => ({
  root: {
    width: 40,
    height: 40,
    fill: "transparent"
  }
});

class IcGreenArrowLeft extends React.Component {

  render() {
    const { classes, className, onClick } = this.props;
    
    return <SvgIcon className = { clsx(classes.root, className) }
                    viewBox = { "0 0 40 40" } 
                    onClick = { onClick } >
      <rect x="1" y="1" width="38" height="38" rx="3" stroke="#54BAC1" strokeWidth="2"/>
      <path d="M22.5 27.5L15 20L22.5 12.5" stroke="#54BAC1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </SvgIcon>
  }
}

export default withStyles(styles)(IcGreenArrowLeft);